import React from 'react'
import cx from 'classnames'

import { INTERNAL_LINKS } from './lintSet'

import './internal-links.css'

type LinkItem = { label: string; link: string }

const linkSet: LinkItem[] = INTERNAL_LINKS

type InternalLinksProps = {
  className?: string
}

function defineLinkRel (link: string) {
  return /^http(|s):\/\/(www\.)?toptal\.com/i.test(link)
    ? undefined
    : 'noreferrer nofollow'
}

export default function InternalLinks ({ className }: InternalLinksProps) {
  return (
    <div
      className={cx('internal-links-root', className)}
      role='complementary'
      title='Hire World Class Talent with Toptal'
    >
      <div className='internal-links-wrapper'>
        <h2 className='internal-links-title'>
          Hire World Class Talent <span>with Toptal</span>
        </h2>
        <ul className='internal-links-list'>
          {linkSet.map(({ link, label }) => (
            <li className='internal-links-item' key={link}>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a href={link} rel={defineLinkRel(link)} target='_blank'>
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
